
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M19.414 1.757l2.829 2.829c.78.78.78 2.047 0 2.828l-2.829 2.829a2.016 2.016 0 01-.413.318v3.565A4.002 4.002 0 0118 22a4.002 4.002 0 01-1-7.874v-3.565a2.021 2.021 0 01-.414-.318l-2.829-2.829A2.021 2.021 0 0113.439 7H9.874A4.008 4.008 0 017 9.875L6.999 14H8a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4a2 2 0 012-2h.999V9.874A4.002 4.002 0 016 2a4.002 4.002 0 013.874 3h3.565c.086-.148.192-.288.318-.414l2.829-2.829c.78-.78 2.047-.78 2.828 0zM8 16H4v4h4v-4zm10 0a2 2 0 10-.001 3.999A2 2 0 0018 16zm0-12.828L15.172 6 18 8.828 20.828 6 18 3.172zM6 4a2 2 0 10-.001 3.999A2 2 0 006 4z","opacity":".75"}})])
          )
        }
      }
    